export default (client) => {
  return {
    /**
     * Returns the global Vokalis settings as exposed by the backend.
     * Shape: { has_token: boolean, has_agent_id: boolean, agent_id: string }
     */
    get() {
      return client.get('/vokalis/settings/')
    },

    /**
     * Updates the Vokalis settings. Only admin users can PATCH.
     * Payload: { token?: string | '' | null, agent_id?: string | '' | null }
     */
    update(values) {
      return client.patch('/vokalis/settings/', values)
    },
  }
}

